// ⌘K command palette (new UI): screens from the sidebar the user's rights allow, module switches, and a search of all
// invoices in the current module through the Invoices list's own saved search (no new API).
export function paletteItems(nav, query) {
	const q = (query || '').trim().toLowerCase();
	const items = [];
	nav.sections.forEach(s => {
		s.items.forEach(i => items.push({ key: 'go:' + i.path, kind: 'go', label: i.label, hint: s.title, path: i.path }));
		if (s.group) s.group.items.forEach(i => items.push({ key: 'go:' + i.path, kind: 'go', label: i.label, hint: s.group.label, path: i.path }));
	});
	// The same name in two places ("Vendors" in Master data and in Reports): the report says it is one.
	const count = items.reduce((m, i) => m.set(i.label, (m.get(i.label) || 0) + 1), new Map());
	items.forEach(i => { if (count.get(i.label) > 1 && /report/i.test(i.hint)) i.label += ' report'; });
	nav.modules.filter(m => !nav.current || m.id !== nav.current.id)
		.forEach(m => items.push({ key: 'mod:' + m.id, kind: 'go', label: `Switch to ${m.label}`, hint: 'Module', path: m.base + '/Dashboard/' }));
	const matches = items.filter(i => !q || i.label.toLowerCase().includes(q) || i.hint.toLowerCase().includes(q));
	const invoices = nav.sections.flatMap(s => s.items).find(i => i.id === 'MIDocuments');
	if (q && invoices && nav.current) {
		matches.unshift({ key: 'search', kind: 'search', label: `Search all ${nav.current.label} invoices for “${query.trim()}”`, hint: 'Invoices', path: invoices.path, text: query.trim(), modelDefId: nav.current.modelDefId });
	}
	return matches.slice(0, 12);
}
